<template>
  <el-dialog :visible.sync="dialogVisible" :title="dialogTitle" :close-on-click-modal="false" @close="dialogClose" width="1500px">
    <div class="massLoss-list">
      <div class="nav">
        <el-form :model="searchForm" label-width="90px" :inline="true" class="demo-form-inline flex1" ref="searchForm">
          <el-form-item label="台账月：">
            <el-date-picker v-model="searchForm.standingBookMonth" size="mini" value-format="yyyyMM" type="month" placeholder="请选择台账月" />
          </el-form-item>
          <el-form-item label="编号：">
            <el-input class="input-show-wrap" v-model="searchForm.ledgerNumber" size="mini" placeholder="请输入编号" :disabled="true" />
          </el-form-item>
          <el-form-item label="标题：">
            <el-input class="input-show-wrap" v-model="searchForm.title" size="mini" placeholder="请输入标题" :disabled="true" />
          </el-form-item>
          <el-form-item label="委托商：">
            <el-input v-model="searchForm.consignorName" size="mini" placeholder="请输入委托商名称" />
          </el-form-item>
          <el-form-item label="供应商：">
            <el-input v-model="searchForm.supplierName" size="mini" placeholder="请输入供应商名称" />
          </el-form-item>

          <el-form-item>
            <el-button size="small" class="searchBtn" @click="searchBtn">查询</el-button>
            <el-button size="small" class="resetBtn" @click="resetBtn">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <el-row>
        <el-col :span="24" style="text-align: end; font-size: 14px !important" class="exportButton">
          <span @click="exportData">导出数据</span>
        </el-col>
      </el-row>
      <div class="content">
        <div class="tableContainer">
          <el-table v-loading="tableLoading" :data="tableDataList" style="width: 100%" border
                    :header-cell-style="headerCellStyle" :span-method="objectSpanMethods" v-if="this.plate === 3">
            <el-table-column prop="standingBookMonth" label="台账月" align="center" min-width="100px" />
            <el-table-column prop="consignorName" label="委托商" align="center" min-width="240px" />
            <el-table-column prop="srCostTypeName" label="收入费用类型" align="center" min-width="100px" />
            <el-table-column prop="srCostNum" label="收入费用数量" align="center" min-width="100px" />
            <el-table-column prop="srTaxRate" label="收入税率" align="center" min-width="100px" />
            <el-table-column prop="srCostAmount" label="收入费用金额" align="center" min-width="100px" />
            <el-table-column prop="offlineNumber" label="线下审批号" align="center" min-width="100px" />
            <el-table-column prop="zcCostTypeName" label="支出费用类型" align="center" min-width="100px" />
            <el-table-column prop="zcCostNum" label="支出费用数量" align="center" min-width="100px" />
            <el-table-column prop="zcTaxRate" label="支出税率" align="center" min-width="100px" />
            <el-table-column prop="zcCostAmount" label="支出费用金额" align="center" min-width="100px" />
            <el-table-column prop="supplierName" label="供应商" align="center" min-width="100px" />
          </el-table>
          <el-table v-loading="tableLoading" :data="TableData" style="width: 100%" border
                    :header-cell-style="headerCellStyle" v-else-if="this.plate === 2">
            <el-table-column prop="standingBookMonth" label="台账月" align="center" min-width="100px" />
            <el-table-column prop="consignorName" label="委托商" align="center" min-width="240px" />
            <el-table-column prop="srRate" label="收入税率" align="center" min-width="100px" />
            <el-table-column prop="taxSrPrice" label="收入总金额" align="center" min-width="100px" />
            <el-table-column prop="consignorNum" label="收入运费数量" align="center" min-width="100px" />
            <el-table-column prop="workType" label="费用类型" align="center" min-width="100px" />
            <el-table-column prop="supplierName" label="供应商" align="center" min-width="100px" />
            <el-table-column prop="zcRate" label="支出税率" align="center" min-width="100px" />
            <el-table-column prop="taxZcPrice" label="支出总金额" align="center" min-width="100px" />
            <el-table-column prop="supplierNum" label="供应商数量" align="center" min-width="100px" />
          </el-table>
          <el-table v-loading="tableLoading" :data="tableData" style="width: 100%" border
                    :header-cell-style="headerCellStyle" :span-method="objectSpanMethod" v-else-if="this.plate === 1">
            <el-table-column prop="standingBookMonth" label="台账月" align="center" min-width="100px" />
            <el-table-column label="收入端" align="center" min-width="100px">
              <el-table-column prop="consignorName" label="委托商" align="center" min-width="240px" />
              <el-table-column prop="srRate" label="运费税率" align="center" min-width="100px" />
              <el-table-column prop="taxSrPrice" label="运费总金额" align="center" min-width="100px" />
              <el-table-column prop="consignorNum" label="收入运费数量" align="center" min-width="100px" />
              <el-table-column prop="zxRate" label="装卸费税率" align="center" min-width="100px" />
              <el-table-column prop="taxZxPrice" label="装卸费总金额" align="center" min-width="100px" />
              <el-table-column prop="loadingUnloadingNum" label="收入装卸费数量" align="center" min-width="100px" />
            </el-table-column>
            <el-table-column label="成本端" align="center" min-width="100px">
              <el-table-column prop="supplierName" label="供应商" align="center" min-width="240px" />
              <el-table-column prop="type" label="费用类型" align="center" min-width="100px">
                <template slot-scope="scope">
                  {{ getType(scope.row.type) }}
                </template>
              </el-table-column>
              <el-table-column prop="zcRate" label="税率" align="center" min-width="100px" />
              <el-table-column prop="taxZcPrice" label="总金额" align="center" min-width="100px" />
              <el-table-column prop="supplierNum" label="供应商数量" align="center" min-width="100px" />
            </el-table-column>
          </el-table>
          <div v-else></div>
        </div>
        <div class="paginationContainer">
          <el-pagination background :page-sizes="[10, 20, 30, 40]" layout="total, sizes, prev, pager, next, jumper" :total="total" @size-change="contractSizeChange" @current-change="contractCurrentChange" :current-page.sync="page" :page-size="rows" />
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
  import { getAccountCoDetail, getAccountCollectDetail, getAccountPageList } from '@/service/account';
  import { getSessionStore } from '@/config/mUtils';
  import { baseUrl } from '@/config/env';

  export default {
    name: 'info',
    data() {
      return {
        dialogVisible: false,
        dialogTitle: '',
        from: {
          consignorName: '',
          supplierName: '',
          standingBookMonth: '',
          summaryId: '',
          submitType: '',
          title: '',
          number: '',
        },
        searchForm: {
          actualSbm: '',
          summaryId: '',
          submitType: '',
          standingBookMonth: '',
          consignorName: '',
          supplierName: '',
          ledgerNumber: '',
          title: '',
        },
        defaultSearchForm: {},
        tableLoading: false,
        tableData: [],//运输
        tableDataList: [],//其他费用
        TableData: [],//库房及其他
        headerCellStyle: {
          color: '#3B3B3B',
          'font-size': '13px',
          height: '48px',
          background: '#E8E8E8',
        },
        page: 1,
        rows: 10,
        total: 0,
        plate: '',
      };
    },
    methods: {
      dialogOpen(type, rowId, plate, ledgerNumber, title) {
        type ? (this.dialogTitle = '财务调账--汇总表') : (this.dialogTitle = '财务台账--汇总表');
        if (type === 1) {
          this.searchForm.submitType = 0;
          this.from.submitType = 0;
        } else if (type === 3) {
          this.searchForm.submitType = 1;
          this.from.submitType = 1;
        }
        this.searchForm.standingBookMonth = '';
        this.searchForm.consignorName = '';
        this.searchForm.supplierName = '';
        this.searchForm.ledgerNumber = ledgerNumber;
        this.searchForm.title = title;
        this.searchForm.summaryId = rowId;
        this.from.summaryId = rowId;
        this.defaultSearchForm = JSON.parse(JSON.stringify(this.searchForm));
        this.dialogVisible = true;
        this.plate = 1000
        setTimeout(()=>{
          this.plate = plate;
          this.searchBtn();
        },100)
      },
      dialogClose() {
        this.dialogVisible = false;
        this.tableData = [];
        this.tableDataList = [];
        this.TableData = [];
        this.total = 0;
      },
      getType(type) {
        switch (type) {
          case 1:
            return '公路运费';
          case 2:
            return '水路运费';
          case 3:
            return '装船费';
          case 4:
            return '卸船费';
          case 5:
            return '过驳费';
          case 6:
            return '转船费';
          case 7:
            return '堆存费';
          case 8:
            return '提车费';
          default:
            return '--';
        }
      },
      // 查询
      searchBtn() {
        this.searchForm.page = 1;
        this.getTableData();

      },
      // 重置
      resetBtn() {
        this.searchForm = JSON.parse(JSON.stringify(this.defaultSearchForm));
      },
      // 合并相同列-板块3
      objectSpanMethods({ row, column, rowIndex, columnIndex }) {
        // data ：需要修改的列数和列的属性 第一列从0开始
        const data = [
          {
            columnIndex: 0,
            value: 'standingBookMonth',
          },
          {
            columnIndex: 1,
            value: 'consignorName',
          },
          {
            columnIndex: 2,
            value: 'srCostTypeName',
          },
          {
            columnIndex: 3,
            value: 'srCostNum',
          },
          {
            columnIndex: 4,
            value: 'srTaxRate',
          },
          {
            columnIndex: 5,
            value: 'srCostAmount',
          },
          {
            columnIndex: 6,
            value: 'offlineNumber',
          },
          {
            columnIndex: 7,
            value: 'zcCostTypeName',
          },
          {
            columnIndex: 8,
            value: 'zcCostNum',
          },
          {
            columnIndex: 9,
            value: 'zcTaxRate',
          },
          {
            columnIndex: 10,
            value: 'zcCostAmount',
          },
          {
            columnIndex: 11,
            value: 'supplierName',
          },
        ];

        for (let index = 0; index < data.length; index++) {
          if (columnIndex === data[index].columnIndex) {
            const _row = this.filterDatas(this.tableDataList, data[index].value, data[index].anotherValue)[rowIndex];
            const _col = _row > 0 ? 1 : 0;
            return {
              rowspan: _row,
              colspan: _col,
            };
          }
        }
      },
      // 根据是否有相同数据返回一个如[2,0,3,0,0]格式的数组(公共的)
      filterDatas(arr, value) {
        let spanOneArr = [];
        let concatOne = 0;
        arr.forEach((item, index) => {
          if (index === 0) {
            spanOneArr.push(1);
          } else {
            if (item['standingBookMonth'] !== arr[index - 1]['standingBookMonth']) {
              spanOneArr.push(1);
              concatOne = index;
            } else if (item[value] === arr[index - 1][value]) {
              spanOneArr[concatOne] += 1;
              spanOneArr.push(0);
            } else {
              spanOneArr.push(1);
              concatOne = index;
            }
          }
        });
        return spanOneArr;
      },
      // 合并相同列
      objectSpanMethod({ row, column, rowIndex, columnIndex }) {
        // data ：需要修改的列数和列的属性 第一列从0开始
        const data = [
          {
            columnIndex: 0,
            value: 'standingBookMonth',
          },
          {
            columnIndex: 1,
            value: 'consignorName',
          },
          {
            columnIndex: 2,
            value: 'srRate',
          },
          {
            columnIndex: 4,
            value: 'consignorNum',
          },
          {
            columnIndex: 3,
            value: 'taxSrPrice',
          },
          {
            columnIndex: 7,
            value: 'loadingUnloadingNum',
          },
        ];
        for (let index = 0; index < data.length; index++) {
          if (columnIndex === data[index].columnIndex) {
            const _row = this.filterData(this.tableData, data[index].value)[rowIndex];
            const _col = _row > 0 ? 1 : 0;
            return {
              rowspan: _row,
              colspan: _col,
            };
          }
        }
      },
      // 根据是否有相同数据返回一个如[2,0,3,0,0]格式的数组(公共的)
      filterData(arr, value) {
        let spanOneArr = [];
        let concatOne = 0;
        arr.forEach((item, index) => {
          if (index === 0) {
            spanOneArr.push(1);
          } else {
            if (item['consignorName'] !== arr[index - 1]['consignorName']) {
              spanOneArr.push(1);
              concatOne = index;
            }
            // name 修改
            else if (item[value] === arr[index - 1][value]) {
              spanOneArr[concatOne] += 1;
              spanOneArr.push(0);
            } else {
              spanOneArr.push(1);
              concatOne = index;
            }
          }
        });
        return spanOneArr;
      },
      // 获取表格数据
      async getTableData() {
        if (this.plate === 3) {
          this.tableLoading = true;
          const res = await getAccountPageList({
            ...this.from,
            page: this.page,
            rows: this.rows,
          });
          this.tableLoading = false;
          if (res.status !== 0) return this.$message.warning(res.message);
          console.log(res.data.records)
          this.tableDataList = res.data.records;
          this.total = res.data.total;
        } else if (this.plate === 2) {
          this.tableLoading = true;
          const res = await getAccountCoDetail({
            ...this.from,
            page: this.page,
            rows: this.rows,
          });
          this.tableLoading = false;
          if (res.status !== 0) return this.$message.warning(res.message);
          this.TableData = res.data.records;
          this.total = res.data.total;
        } else {
          this.tableLoading = true;
          const res = await getAccountCollectDetail({
            ...this.searchForm,
            page: this.page,
            rows: this.rows,
          });
          this.tableLoading = false;
          if (res.status !== 0) return this.$message.warning(res.message);
          this.tableData = res.data.records;
          this.total = res.data.total;
        }
      },
      contractSizeChange(row) {
        this.rows = row;
        this.page = 1;
        this.getTableData();
      },
      contractCurrentChange(page) {
        this.page = page;
        this.getTableData();
      },
      // 导出数据
      exportData() {
        let token = getSessionStore('token');
        if (this.plate === 3) {
          window.exportExcel(
            `${baseUrl}/platform/otherCost/standingBook/exportXls?access_token=${token}`,
            {
              ...this.from,
              number: this.searchForm.ledgerNumber,
              title: this.searchForm.title === null ? '' : this.searchForm.title,
            },
            '财务台账汇总表',
          );
        } else if (this.plate === 2) {
          const { standingBookMonth, consignorName, supplierName, summaryId } = this.from;
          // window.location.href = `${baseUrl}/platform/settlement/portAndWarehouse/accountCollect/export?access_token=${token}&standingBookMonth=${standingBookMonth}&consignorName=${consignorName}&supplierName=${supplierName}&summaryId=${summaryId}&number=${this.searchForm.ledgerNumber}&title=${this.searchForm.title === null ? '' : this.searchForm.title}`;
          window.exportExcelGet('/platform/settlement/portAndWarehouse/accountCollect/export', `standingBookMonth=${standingBookMonth}&consignorName=${consignorName}&supplierName=${supplierName}&summaryId=${summaryId}&number=${this.searchForm.ledgerNumber}&title=${this.searchForm.title === null ? '' : this.searchForm.title}`);
        } else {
          const { standingBookMonth, consignorName, supplierName, actualSbm, submitType, summaryId, ledgerNumber, title } = this.searchForm;
          // window.location.href = `${baseUrl}/platform/settlement/accountCollect/countExportXls?access_token=${token}&standingBookMonth=${standingBookMonth}&consignorName=${consignorName}&supplierName=${supplierName}&actualSbm=${actualSbm}&submitType=${submitType}&summaryId=${summaryId}&number=${ledgerNumber}&title=${title === null ? '' : title}`;
          window.exportExcelGet('/platform/settlement/accountCollect/countExportXls', `standingBookMonth=${standingBookMonth}&consignorName=${consignorName}&supplierName=${supplierName}&actualSbm=${actualSbm}&submitType=${submitType}&summaryId=${summaryId}&number=${ledgerNumber}&title=${title === null ? '' : title}`)
        }
      },
    },
  };
</script>

<style lang="scss">
  .massLoss-list {
    //width:100%;
    padding: 20px 15px 0 25px;
    height: 100%;
    /*overflow: auto;*/
    .nav {
      /*width:100%;*/
      display: flex;
      /*align-items: center;*/
      /*height:30px;*/
      overflow: hidden;

      .flex1 {
        flex: 1;
      }

      .el-input {
        width: 150px;
      }

      .el-select {
        width: 150px;
      }

      ::v-deep {
        label.el-form-item__label {
          font-weight: 500;
          color: #101010;
        }
      }
    }

    ::v-deep .detail {
      .el-form-item {
        margin-bottom: 2px;

        .el-form-item__label {
          /*color: #060606;*/
          font-weight: 700;
        }
      }

      .line {
        width: 12px;
        height: 32px;
        background-color: rgba(51, 84, 131, 100);
        margin-right: 10px;
      }

      .line + span {
        font-size: 16px;
        color: rgba(51, 84, 131, 100);
        font-weight: 600;
      }

      width: 100%;
      padding: 10px 0 20px 20px;

      .baseInfo {
        display: flex;
        flex-direction: column;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(249, 166, 6);
            margin-left: 10px;
          }
        }

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;
          font-size: 14px;

          .center-f {
            display: flex;
          }
        }
      }

      .operation {
        display: flex;
        flex-direction: column;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;
          font-size: 14px;
        }

        &Table {
          width: 100%;
          margin-top: 10px;
          padding-right: 20px;
        }
      }
    }

    ::v-deep .add {
      .el-form-item__label {
        font-weight: 700;
      }

      width: 100%;

      .baseInfo {
        display: flex;
        flex-direction: column;

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;
          font-size: 14px;

          .center-f {
            display: flex;
          }

          .yang {
            .el-form-item {
              .el-form-item__error {
                left: 40px;
              }

              margin-bottom: 5px;

              .el-form-item__label {
                // width: 150px !important;
                /*color: #060606;*/
              }
            }
          }

          .repair {
            .el-input {
              width: 80%;
            }

            .el-form-item {
              .el-form-item__error {
                /*left: 41px;*/
                padding-top: 0px;
              }

              margin-bottom: 7px;

              .el-form-item__label {
                /*width: 155px  !important;*/
                /*color: #060606;*/
              }
            }

            .el-upload-list__item {
              width: 100px;
              height: 100px;
            }

            .el-upload--picture-card {
              width: 100px;
              height: 100px;
              line-height: 100px;
            }

            /*display: none;*/
            .imgUp {
              display: flex;
              flex-direction: column;

              .imgLength {
                display: flex;
                align-items: center;
                width: 100%;

                span {
                  margin-left: auto;
                  color: rgb(183, 183, 183);
                  font-size: 16px;
                }
              }
            }
          }
        }
      }

      .btnContainer {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 13px;
        margin-top: 20px;

        button {
          margin: 0 15px;
        }
      }
    }

    ::v-deep {
      .el-dialog__header {
        padding: 9px 20px 9px;
        background: #335483;
      }

      .el-dialog__title {
        line-height: 24px;
        font-size: 14px;
        color: #ffffff;
      }

      .el-dialog__headerbtn {
        top: 9px;
      }

      .el-dialog__headerbtn .el-dialog__close {
        color: #fff;
        font-size: 25px;
      }

      .el-dialog__body {
        padding: 0;
        overflow: auto;
        max-height: 75vh;
        color: #606266;
      }

      .el-form--inline .el-form-item {
        margin-bottom: 5px;
      }
    }
  }

  .tableContainer {
    margin: 10px 0 30px 0;
  }

  .exportButton {
    span {
      color: rgba(51, 136, 255, 1);
      font-size: 14px;

      &:hover {
        cursor: pointer;
      }
    }
  }

  .input-show-wrap input {
    color: red !important;
  }
</style>
